import { useEffect, useState } from 'react';
import { getPackingTypesData, unNumberInfo } from '../../../api/shipmentForms';

interface Props {
  packagesForm: any;
  setPackagesForm: any;
  validating: boolean;
  formValidations: any;
  setFormValidations: any;
}
function DGFields({
  packagesForm,
  setPackagesForm,
  validating,
  formValidations,
  setFormValidations,
}: Props) {
  const [shippingNamesOption, setShippingNamesOptions] = useState<any>([]);
  const [packingTypeList, setPackingTypeList] = useState<any>([]);
  const [shippingNamesInfo, setShippingNamesInfo] = useState<any>();
  const [shippingNamesDataOption, setShippingNamesDataOptions] = useState<any>(
    []
  );

  function getUnInfo() {
    unNumberInfo({ un_number: Number(packagesForm?.un_number) })
      .then((response) => {
        if (!response?.data?.is_error) {
          let data = response.data.content;
          let firstNameOption = data?.proper_shipping_names[0];
          setShippingNamesInfo(data?.shipping_name_data);

          let dataOptions = firstNameOption
            ? data?.shipping_name_data?.[firstNameOption]
            : [];

          setShippingNamesOptions(data?.proper_shipping_names);
          setShippingNamesDataOptions(dataOptions);

          // setPackagesForm({
          //   ...packagesForm,
          //   is_nos: data?.is_nos,
          //   is_neq: data?.is_neq,
          //   proper_shipping_name: firstNameOption,
          //   packing_group:
          //     dataOptions && dataOptions[0] ? dataOptions[0]?.code : undefined,
          //   packing_group_name:
          //     dataOptions && dataOptions[0]
          //       ? dataOptions[0]?.details
          //       : undefined,
          // });
          // setFormValidations({
          //   ...formValidations,
          //   packing_group_name:
          //     dataOptions && dataOptions[0] && dataOptions[0]?.details,
          // });

          //just testingggggggggg

          if (data) {
            getPackingTypesData()
              .then((response) => {
                if (!response?.data?.is_error) {
                  let secondData = response?.data?.content;
                  setPackagesForm((prevPackagesForm: any) => ({
                    ...prevPackagesForm,
                    is_nos: data?.is_nos,
                    is_neq: data?.is_neq,
                    proper_shipping_name: firstNameOption,
                    packing_group:
                      dataOptions && dataOptions[0]
                        ? dataOptions[0]?.code
                        : undefined,
                    packing_group_name:
                      dataOptions && dataOptions[0]
                        ? dataOptions[0]?.details
                        : undefined,
                    packing_type: secondData && secondData[0]?.code,
                    packing_type_name: secondData && secondData[0]?.combined,
                  }));

                  setFormValidations((prevFormValidations: any) => ({
                    ...prevFormValidations,
                    packing_type:
                      secondData && secondData[0] && secondData[0]?.code !== '',
                    packing_group_name:
                      dataOptions && dataOptions[0] && dataOptions[0]?.details,
                  }));

                  setPackingTypeList(secondData);
                }
              })
              .catch((e) => {});
          }
        }
      })
      .catch((e) => {});
  }

  // function getPackingType() {
  //   getPackingTypesData()
  //     .then((response) => {
  //       if (!response?.data?.is_error) {
  //         let data = response?.data?.content;
  //         setPackagesForm({
  //           ...packagesForm,
  //           packing_type: data && data[0]?.code,
  //           packing_type_name: data && data[0]?.combined,
  //         });

  //         setFormValidations({
  //           ...formValidations,
  //           packing_type: data && data[0] && data[0]?.code !== '',
  //         });

  //         setPackingTypeList(data);
  //       }
  //     })
  //     .catch((e) => {});
  // }
  const handleMainDgQtyFocus = () => {
    getUnInfo();
  };

  return (
    <div
      className=''
      id='dg_fields'
    >
      <div className='row mt-4'>
        <div className='col-sm-12 col-md-4 col-lg-4'>
          <label
            className='globalInputLabel pb-2'
            htmlFor='main_un'
          >
            UN/ID<span className='text-danger fw-bold ml-2'>*</span>
          </label>
          <input
            className={`form-control ubbe-input ${
              packagesForm?.un_number ? 'highlighted-border' : ''
            }`}
            id='main_un'
            placeholder='Ex: 1900'
            autoComplete='new-password'
            onBlur={() => {
              'get_dg_data(this)';
            }}
            minLength={2}
            maxLength={4}
            value={packagesForm?.un_number}
            onChange={(e) => {
              setPackagesForm({
                ...packagesForm,
                un_number: e.target.value,
              });
              setFormValidations({
                ...formValidations,
                un_number:
                  e.target.value.length > 1 && e.target.value.length < 5,
              });
            }}
          />
          {validating &&
            (!packagesForm?.un_number ||
              packagesForm?.un_number.length > 4 ||
              packagesForm?.un_number.length < 2) && (
              <div
                className='error_text'
                id='un_error'
              >
                Please provide a valid UN Number.
              </div>
            )}
        </div>
        <div className='col-sm-12 col-md-4 col-lg-4'>
          <label
            className='globalInputLabel pb-2'
            htmlFor='main_dg_qty'
          >
            DG Quantity{' '}
            <span
              className='text-danger fw-bold'
              style={{ marginLeft: '3px' }}
            >
              *
            </span>
          </label>
          <input
            className={`form-control ubbe-input ${
              packagesForm?.dg_quantity ? 'highlighted-border' : ''
            }`}
            id='main_dg_qty'
            onFocus={handleMainDgQtyFocus}
            placeholder='Ex: 1'
            autoComplete='new-password'
            value={packagesForm?.dg_quantity}
            onChange={(e) => {
              setPackagesForm((prevPackagesForm: any) => ({
                ...prevPackagesForm,
                dg_quantity: e.target.value,
              }));

              setFormValidations((prevFormValidations: any) => ({
                ...prevFormValidations,
                dg_quantity: e.target.value !== '',
              }));
            }}
          />
          {validating &&
            (!packagesForm?.dg_quantity ||
              packagesForm?.dg_quantity === '') && (
              <div
                className='error_text'
                id='quantity_error'
              >
                Please provide a valid quantity.
              </div>
            )}
        </div>
        <div className='col-sm-12 col-md-4 col-lg-4'>
          <label
            className='globalInputLabel pb-2'
            htmlFor='main_group'
          >
            Packing Group{' '}
            <span
              className='text-danger fw-bold'
              style={{ marginLeft: '3px' }}
            >
              *
            </span>
          </label>
          <select
            className={`form-select ubbe-input ${
              packagesForm?.packing_group_name ? 'highlighted-border' : ''
            }`}
            id='main_group'
            data-width='100%'
            data-size='8'
            value={packagesForm?.packing_group_name}
            onChange={(e) => {
              const selectedOption = shippingNamesDataOption.find(
                (option: any) => option.details === e.target.value
              );

              setPackagesForm({
                ...packagesForm,
                packing_group_name: selectedOption?.details,
                packing_group_code: e.target.value,
              });
            }}
          >
            {shippingNamesDataOption &&
              shippingNamesDataOption.length > 0 &&
              shippingNamesDataOption.map((option: any, index: number) => (
                <option
                  key={index}
                  value={option.details}
                >
                  {option?.details}
                </option>
              ))}
          </select>

          {validating &&
            (!packagesForm?.packing_group_name ||
              packagesForm?.packing_group_name === '') && (
              <div
                className='error_text'
                id='pk_error'
              >
                Please select a Packing Group.
              </div>
            )}
        </div>
      </div>

      <div className='row mt-4'>
        <div className='col-sm-12'>
          <label
            className='globalInputLabel pb-2'
            htmlFor='main_shipping_name'
          >
            Proper Shipping Name
          </label>
          <select
            className={`form-select ubbe-input ${
              packagesForm?.proper_shipping_name ? 'highlighted-border' : ''
            }`}
            id='main_shipping_name'
            data-width='100%'
            data-size='8'
            value={packagesForm?.proper_shipping_name}
            onChange={(e) => {
              let valueInput = e.target.value;
              setShippingNamesDataOptions(shippingNamesInfo?.[valueInput]);
              let selectedShippingInfo =
                shippingNamesInfo?.[valueInput] &&
                shippingNamesInfo[valueInput][0];

              setPackagesForm({
                ...packagesForm,
                proper_shipping_name: valueInput,
                packing_group_name: selectedShippingInfo?.details || '',
                packing_group: selectedShippingInfo?.code || '',
              });

              setFormValidations({
                ...formValidations,
                packing_group_name: selectedShippingInfo,
              });
            }}
          >
            {shippingNamesOption &&
              shippingNamesOption.length > 0 &&
              shippingNamesOption.map((option: any, index: number) => (
                <option
                  key={index}
                  value={option.value}
                >
                  {option}
                </option>
              ))}
          </select>
        </div>
      </div>

      <div className='row mt-4'>
        <div className='col-sm-12'>
          <label
            className='globalInputLabel pb-2'
            htmlFor='main_packing_type'
          >
            Packing Type
          </label>
          <select
            className={`form-select ubbe-input ${
              packagesForm?.packing_type ? 'highlighted-border' : ''
            }`}
            id='main_packing_type'
            data-width='100%'
            data-size='8'
            value={packagesForm?.packing_type}
            onChange={(e: any) => {
              const selectedOption = packingTypeList.find(
                (option: any) => option.code === e.target.value
              );

              setPackagesForm({
                ...packagesForm,
                packing_type: selectedOption?.code,
                packing_type_name: selectedOption?.combined,
              });

              setFormValidations({
                ...formValidations,
                packing_type:
                  selectedOption?.code && selectedOption?.code !== '',
              });
            }}
          >
            {packingTypeList &&
              packingTypeList.length > 0 &&
              packingTypeList.map((option: any, index: number) => (
                <option
                  key={index}
                  value={option?.code}
                >
                  {option?.combined}
                </option>
              ))}
          </select>
          {validating &&
            packagesForm?.packing_type &&
            packagesForm?.packing_type === '' && (
              <div
                className='error_text'
                id='year_error'
              >
                Please select a Packing Type.{' '}
              </div>
            )}
        </div>
      </div>
      {packagesForm?.is_nos && (
        <div
          className='row mt-4'
          id='nos_row'
        >
          <div className='col-sm-12'>
            <label
              className='globalInputLabel pb-2'
              htmlFor='main_nos'
            >
              N.O.S Description{' '}
              <span
                className='text-danger fw-bold'
                style={{ marginLeft: '3px' }}
              >
                *
              </span>
            </label>
            <input
              className={`form-control ubbe-input ${
                packagesForm?.dg_nos_description ? 'highlighted-border' : ''
              }`}
              id='main_nos'
              placeholder='N.O.S Description'
              autoComplete='new-password'
              maxLength={100}
              value={packagesForm?.dg_nos_description}
              onChange={(e) => {
                setPackagesForm({
                  ...packagesForm,
                  dg_nos_description: e.target.value,
                });
              }}
            />
            {validating && packagesForm?.dg_nos_description === '' && (
              <div
                className='error_text'
                id='year_error'
              >
                Please provide a N.E.Q Description.
              </div>
            )}
          </div>
        </div>
      )}
      {packagesForm?.is_neq && (
        <div
          className='row mt-4'
          id='neq_row'
        >
          <div className='col-sm-12'>
            <label
              className='globalInputLabel pb-2'
              htmlFor='main_neq'
            >
              N.E.Q Description{' '}
              <span
                className='text-danger fw-bold'
                style={{ marginLeft: '3px' }}
              >
                *
              </span>
            </label>
            <input
              className={`form-control ubbe-input ${
                packagesForm?.is_neq ? 'highlighted-border' : ''
              }`}
              id='main_neq'
              placeholder='NEQ Description'
              autoComplete='new-password'
              maxLength={100}
              value={packagesForm?.is_neq}
              onChange={(e) => {
                setPackagesForm({
                  ...packagesForm,
                  is_neq: e.target.value,
                });
              }}
            />
            {validating && packagesForm?.dg_neq_description === '' && (
              <div
                className='error_text'
                id='year_error'
              >
                Please provide a N.E.Q Description.
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default DGFields;
